<template>
  <panel
    :title="nuevo ? 'Registrar Nuevo GLP SA' : 'Editar GLP SA'"
    panelClass="panel-with-tabs"
    variant="default"
    ref="header"
    noButton="false"
  >
    <form action="/" method="POST">
      <fieldset>
        <tabWizard
          @evento="show($event)"
          :completado1="proceso_tab.paso1_completado"
          :completado2="proceso_tab.paso2_completado"
          :completado3="proceso_tab.paso3_completado"
          :tab1="tab.paso1"
          :tab2="tab.paso2"
          :tab3="tab.paso3"
        />
        <paso1
          :duplicar="duplicar"
          :certificadosAsignados="certificadosAsignados"
          v-show="tab.paso1"
          :tipo="'glp'"
          :registro="glp"
          :nuevo="nuevo"
          :locales="locales"
          :ingenieros="ingenieros"
          @guardar="$emit('guardar', $event)"
          @actualizar="$emit('actualizar', $event)"
          @cancelar="$emit('cancelar')"
        />
        <paso2
          v-show="tab.paso2"
          :codeQR="glp.codeQR"
          @max_fotos="proceso_tab.paso2_completado = true"
        />
        <paso3
          v-show="tab.paso3"
          :Id="glp.Id"
          :pdf1="glp.pdf1"
          @completado="proceso_tab.paso3_completado = true"
          :pdf2="glp.pdf2"
          :url="URL_BASE() + 'glpsa'"
          :tipo="'glpsa'"
        />
      </fieldset>
    </form>
  </panel>
</template>
<script>
import tabWizard from "../TabWizarr.vue";
import paso1 from "../Paso1SA.vue";
import paso2 from "../Paso2SA.vue";
import paso3 from "../Paso3.vue";
import dropzone from "../DropZone.vue";
export default {
  name: "GLPSAComponent",
  props: ["registro", "nuevo", "duplicar", "ingenieros", "certificadosAsignados","locales"],
  components: {
    dropzone,
    paso1,
    paso2,
    paso3,
    tabWizard,
  },
  data() {
    return {
      max_foto: 0,
      data: [],
      tab: {
        paso1: true,
        paso2: false,
        paso3: false,
      },
      proceso_tab: {
        paso1_completado: false,
        paso2_completado: false,
        paso3_completado: false,
      },
      glp: {
        Id: "",
        certificado: "",
        propietario: "",
        placa_rodaje: "",
        categoria: "",
        marca: "",
        modelo: "",
        version: "",
        anio_fabrica: "",
        vin_nro_serie: "",
        nro_motor: "",
        cilindrada: "",
        combustible: "",
        ejes_ruedas: "",
        asientos_pasajeros: "",
        largo_ancho_alto: "",
        peso_neto: "",
        peso_bruto: "",
        carga_util: "",
        reductor_marca: "",
        reductor_modelo: "",
        reductor_nro_serie: "",
        cilindro_marca: "",
        cilindro_modelo: "",
        cilindro_nro_serie: "",
        ciudad: "",
        Taller_Autorizado: "",
        fecha_registro: "",
        fecha_expiracion: "",
        pdf1: "",
        pdf1Archivo: null,
        pdf2: "",
        idciudad: "",
        pdf2Archivo: null,
        codeQR: "",
        fecha_add: "",
        fecha_update: "",
      },
    };
  },
  created() {

    if (!this.nuevo) {
      if (this.duplicar) {
        this.glp = {
          ...this.registro,
        };
        this.tab.paso1 = true;
      } else {
        this.glp = {
          ...this.registro,
        };
        this.proceso_tab.paso1_completado = true;
        //  this.proceso_tab.paso2_completado = true;
        if (
          this.glp.pdf1 == "" ||
          this.glp.pdf2 == "" ||
          this.glp.pdf1 == "#" ||
          this.glp.pdf2 == "#"
        ) {
          this.proceso_tab.paso2_completado = false;
          this.proceso_tab.paso3_completado = false;
        } else {
          this.proceso_tab.paso2_completado = true;
          this.proceso_tab.paso3_completado = true;
        }

        this.tab.paso1 = true;
      }
    }
  },
  methods: {
    show: function (x) {
      this.tab.paso1 = false;
      this.tab.paso2 = false;
      this.tab.paso3 = false;

      switch (x) {
        case "paso1":
          this.tab.paso1 = true;
          break;
        case "paso2":
          this.tab.paso2 = true;
          break;
        case "paso3":
          this.tab.paso3 = true;
          break;

        default:
          this.tab.paso1 = true;
          break;
      }
    },
    validarFormulario(tipo) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (tipo == "guardar") {
            this.$emit("guardar", this.glp);
          } else {
            this.$emit("actualizar", this.glp);
          }
          return;
        }
      });
    },
  },
  watch: {
    nuevo() {
      this.glp = {
        ...this.registro,
      };
      this.proceso_tab.paso1_completado = true;
      this.tab.paso1 = false;
      this.tab.paso2 = true;
    },
    certificadosAsignados(newQuestion) {
      this.certificadosAsignados = newQuestion;
    },
    duplicar() {
      this.glp = {
        ...this.registro,
      };
      this.proceso_tab.paso1_completado = true;
      this.tab.paso1 = false;
      this.tab.paso2 = true;
    },
  },
};
</script>